import React from 'react'
import SerTab from './SerTab/SerTab'
const Categories = () => {
  return (
    <div id="categories" className="my-12 bg-gray-100 text-base  text-2xl lg:text-3xl mb-4 ">
        <h2 className='text-3xl my-2'>
            Categories
        </h2>
        <div className="grid grid-cols-1 lg:grid-cols-3 grid-rows-6 gap-2">
          <SerTab name="Men" link="/products/men" height ="h-216" backgroundImage={`https://res.cloudinary.com/custoshoe/image/upload/v1693514023/oe3o1gxqu7f1by5yneta.webp`}/>
          <SerTab name="Women" link="/products/women" backgroundImage={`https://res.cloudinary.com/custoshoe/image/upload/v1693513970/d7pg2q937tdjppt5sebk.jpg`}/>
          <SerTab name="Kids" link="/products/kids" backgroundImage={`https://res.cloudinary.com/custoshoe/image/upload/v1693513969/ah4mymqwhnx24phogfui.jpg`}/>
        </div>
    </div>
  )
}

export default Categories